export const MESSAGE = {
  'auth.email not found': 'invalidEmail',
  'auth.email must be an email': 'invalidEmailFormat',
  'auth.email already exists': 'existEmail',
  'auth.password incorrect': 'invalidPassword',
  'auth.email is banned': 'bannedEmail',
  'auth.email ru mail': 'ruEmail',
}
